import * as React from 'react'
import Button from '@mui/material/Button'
import {styled} from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import HelpIcon from '@mui/icons-material/Help'
import Box from '@mui/material/Box'
import {useRef} from 'react'

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}))

export interface DialogTitleProps {
  id: string
  children?: React.ReactNode
  onClose: () => void
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const {children, onClose, ...other} = props

  return (
    <DialogTitle sx={{m: 0, p: 2}} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon/>
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

export default function ShortcutsDialog() {
  const noopRef = useRef(null)
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = (e: any) => {
    setOpen(true)
    // @ts-ignore
    noopRef.current?.focus()
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <IconButton onClick={handleClickOpen}>
        <HelpIcon/>
      </IconButton>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Keyboard Shortcuts
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Box
            component="img"
            sx={{
              width: "400px"
            }}
            src='/images/cover.png'
            alt='Keyboard Shortcuts Image'
          />
        </DialogContent>
      </BootstrapDialog>
      <Button sx={{position: 'absolute', left: '-500px'}} ref={noopRef} onClick={() => {}}>NO OP</Button>
    </div>
  )
}
